import { render } from "./wokerDetail10.vue?vue&type=template&id=46f7be56&scoped=true"
import script from "./wokerDetail10.vue?vue&type=script&lang=js"
export * from "./wokerDetail10.vue?vue&type=script&lang=js"

import "./wokerDetail10.vue?vue&type=style&index=0&id=46f7be56&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46f7be56"]])

export default __exports__